export function compareImageNodes(a, b) {
  return (Number(a?.x || 0) - Number(b?.x || 0))
    || (Number(a?.y || 0) - Number(b?.y || 0))
    || String(a?.id || '').localeCompare(String(b?.id || ''))
}

export function compareTextNodes(a, b) {
  return (Number(a?.y || 0) - Number(b?.y || 0))
    || (Number(a?.x || 0) - Number(b?.x || 0))
    || String(a?.id || '').localeCompare(String(b?.id || ''))
}

export function centerOf(node) {
  return { x: Number(node?.x || 0) + Number(node?.width || 280) / 2, y: Number(node?.y || 0) + Number(node?.height || 160) / 2 }
}
